import { render, staticRenderFns } from "./typography-text.vue?vue&type=template&id=f2656b16&scoped=true&"
import script from "./typography-text.vue?vue&type=script&lang=js&"
export * from "./typography-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2656b16",
  null
  
)

export default component.exports